<template>
  <Modal
    :open="displayModal"
    title="View Video"
    :showEscapeButton="false"
    :showAcceptButton="false"
    @close="displayModal = false"
  >
    <YouTubePlayer
      v-if="data.youtube_id !== undefined"
      :youtube_id="data.youtube_id"
      class="rounded-lg overflow-hidden"
    />
    <div class="w-full flex flex-row justify-center items-center">
      <div
        class="bg-gray-200 mt-4 inline-block px-3 py-1.5 rounded-lg space-x-2"
      >
        <i class="fa-brands fa-youtube text-gray-600"></i>
        <a
          class="text-blue-500 text-center"
          :href="'https://www.youtube.com/watch?v=' + data.youtube_id"
          target="_blank"
          >{{ "https://www.youtube.com/watch?v=" + data.youtube_id }}</a
        >
      </div>
    </div>
    <div class="mt-4">{{ data.description }}</div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import YouTubePlayer from "@/components/media/components/YouTubePlayer";

export default {
  data() {
    return {
      displayModal: false,
      data: {}
    };
  },

  components: {
    Modal,
    YouTubePlayer
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("stringer-view-video-open-modal", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("stringer-view-video-open-modal", this.open);
  },

  methods: {
    close() {
      this.displayModal = false;
    },

    open(data) {
      this.displayModal = true;
      this.data = data;
    }
  }
};
</script>
